import md5 from 'js-md5';
export default () => md5(Math.floor(new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000) + 'aFXBxYmkClsw46y7b8C5qN56zs')